export const getConfig = () => require('./config.json')
export const getAwsConfig = () => require('./aws.json')
